/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CityInputs */

const en_city = /** @type {(inputs: CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_city = /** @type {(inputs: CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stadt`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {CityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const city = /** @type {((inputs?: CityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_city(inputs)
	return de_city(inputs)
});